import React from 'react';
import { Cascader } from 'antd';
import { CustomComponentProps, CascaderOption } from '../types';

/**
 * Custom Cascader wrapper component for multi-level selects
 * Perfect for hierarchical data like Country > City > District
 */
export interface MyCascaderProps extends CustomComponentProps {
  options?: CascaderOption[];
  multiple?: boolean;
  showSearch?: boolean;
  allowClear?: boolean;
  changeOnSelect?: boolean;
  displayRender?: (labels: string[]) => React.ReactNode;
  loadData?: (selectedOptions: CascaderOption[]) => void;
  size?: 'small' | 'middle' | 'large';
  expandTrigger?: 'click' | 'hover';
}

const MyCascader: React.FC<MyCascaderProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  readonly,
  options = [],
  multiple = false,
  showSearch = true,
  allowClear = true,
  changeOnSelect = false,
  displayRender,
  loadData,
  size = 'middle',
  expandTrigger = 'click',
  ...rest
}) => {
  const handleChange = (selectedValue: any, selectedOptions: any) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <Cascader
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled || readonly}
      options={options}
      multiple={multiple}
      showSearch={showSearch}
      allowClear={allowClear}
      changeOnSelect={changeOnSelect}
      displayRender={displayRender}
      loadData={loadData}
      size={size}
      expandTrigger={expandTrigger}
      {...rest}
    />
  );
};

export default MyCascader;
